export default "__VITE_ASSET__71238603__"